import React, { useState } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import { BLOCKCHAINS } from '../../config/blockchains';
import "react-datepicker/dist/react-datepicker.css";
import ButtonWarning from ".././Button-warning";

function AddNewToken({ tableItems, isVisible, onClose }) {
  const [newToken, setNewToken] = useState({});
  const [manualContractAddress, setManualContractAddress] = useState("");
  const [useManualAddress, setUseManualAddress] = useState(false);
  const tableItemsArray = Array.isArray(tableItems)
    ? tableItems
    : Object.values(tableItems);

  const handleCloseNewTokenClick = () => {
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const coingeckoResponse = await axios.get(
        `https://api.coingecko.com/api/v3/coins/${newToken.ticker}?localization=false&tickers=false&market_data=true&community_data=false&developer_data=false&sparkline=false`
      );

      const logoUrl = coingeckoResponse.data.image.small;
      let contractAddress = coingeckoResponse.data.platforms;
      const decimals = coingeckoResponse.data.detail_platforms;

      if (useManualAddress && manualContractAddress) {
        contractAddress = {
          [newToken.blockchain]: manualContractAddress
        };
      }

      const updatedToken = {
        ...newToken,
        logo: logoUrl,
        contract: contractAddress,
        decimals: decimals,
      };

      const existingTickers =
        tableItemsArray.length > 0 && Array.isArray(tableItemsArray[0])
          ? tableItemsArray[0].map((item) => item.ticker)
          : [];

      if (existingTickers.includes(newToken.ticker)) {
        alert("Token already exists in your list!");
        return;
      }

      await axios.post(
        "https://cryptools-server-production.up.railway.app/api/user/addToken",
        updatedToken,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setNewToken({});
      setManualContractAddress("");
      setUseManualAddress(false);
      alert("Token added successfully!");
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert("Error adding token. Please check the details and try again.");
    }
  };

  const handleChange = (e) => {
    setNewToken({
      ...newToken,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div
      className={`fixed top-0 right-0 bottom-0 left-0 z-[200] overflow-hidden backdrop-blur-lg ${
        isVisible ? "flex" : "hidden"
      }`}
    >
      <form
        onSubmit={handleSubmit}
        className="flex flex-col w-11/12 md:w-1/3 justify-around mt-2 item-left md:item-center p-4 border-2 rounded-lg z-[200] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/3 bg-white"
      >
        <div className="flex ">
          <label htmlFor="ticker" className="self-center w-1/4 form-label">
            <a
              href="https://www.coingecko.com/"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: "underline" }}
            >
              API id
            </a>
          </label>
          <input
            type="text"
            name="ticker"
            id="ticker"
            className="w-3/4 px-3 py-2 my-1 ml-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            onChange={handleChange}
            value={newToken.ticker || ""}
            required
          />
        </div>
        <div className="flex">
          <label htmlFor="blockchain" className="self-center w-1/4 form-label">
            Blockchain
          </label>
          <select
            name="blockchain"
            id="blockchain"
            className="w-3/4 px-3 py-2 my-1 ml-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            onChange={handleChange}
            value={newToken.blockchain || ""}
            required
          >
            <option value="" disabled>
              Select a blockchain
            </option>
            {BLOCKCHAINS.map(chain => (
        <option key={chain.value} value={chain.value}>
          {chain.label}
        </option>
      ))}
          </select>
        </div>
        <div className="flex">
          <label htmlFor="to_receive" className="self-center w-1/4 form-label">
            To receive
          </label>
          <input
            type="number"
            name="to_receive"
            id="to_receive"
            className="w-3/4 px-3 py-2 my-1 ml-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            onChange={handleChange}
            value={newToken.to_receive || ""}
            required
          />
        </div>
        <div className="flex">
          <label htmlFor="vestingDate" className="self-center w-1/4 form-label">
            Vesting End
          </label>
          <DatePicker
            name="vestingDate"
            id="vestingDate"
            className="w-3/4 px-3 py-2 my-1 ml-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            selected={newToken.vestingDate}
            onChange={(date) => setNewToken({ ...newToken, vestingDate: date })}
            dateFormat="yyyy-MM-dd"
          />
        </div>
        <div className="flex">
          <label htmlFor="to_receive" className="self-center w-1/4 form-label">
            Launchpad
          </label>
          <select
            className="w-3/4 px-3 py-2 my-1 ml-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            name="launchpad"
            onChange={handleChange}
            value={newToken.launchpad || ""}
          >
            <option value="Select">Select a launchpad</option>
            <option value="DAO Maker">DAO Maker</option>
            <option value="Seedify">Seedify</option>
            <option value="Infinity Pad">Infinity Pad</option>
            <option value="Direct">Direct</option>
          </select>
        </div>
        <div className="flex">
          <label htmlFor="to_receive" className="self-center w-1/4 form-label">
            Claim portal
          </label>
          <input
            type="text"
            name="claimPortal"
            id="claimPortal"
            className="w-3/4 px-3 py-2 my-1 ml-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            onChange={handleChange}
            value={newToken.claimPortal || ""}
          />
        </div>
        <div className="flex">
          <label htmlFor="to_receive" className="self-center w-1/4 form-label">
            Tx link
          </label>
          <input
            type="text"
            name="paymentTransaction"
            id="paymentTransaction"
            className="w-3/4 px-3 py-2 my-1 ml-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            onChange={handleChange}
            value={newToken.paymentTransaction || ""}
          />
        </div>
        <div className="flex items-center mt-2">
          <input
            type="checkbox"
            id="useManualAddress"
            checked={useManualAddress}
            onChange={(e) => setUseManualAddress(e.target.checked)}
            className="mr-2"
          />
          <label htmlFor="useManualAddress">Use manual contract address</label>
        </div>

        {useManualAddress && (
          <div className="flex">
            <label htmlFor="manualContractAddress" className="self-center w-1/4 form-label">
              Contract Address
            </label>
            <input
              type="text"
              name="manualContractAddress"
              id="manualContractAddress"
              className="w-3/4 px-3 py-2 my-1 ml-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              onChange={(e) => setManualContractAddress(e.target.value)}
              value={manualContractAddress}
              required={useManualAddress}
            />
          </div>
        )}

        <div className="flex justify-center gap-4 mt-4">
          <button className="px-10 py-3.5 w-full text-center rounded-md shadow-md block sm:w-auto cursor-pointer duration-300 bg-indigo-600 text-white" type="submit">Save</button>
          <ButtonWarning text={"Close"} func={handleCloseNewTokenClick} />
        </div>
      </form>
    </div>
  );
}

export default AddNewToken;